import React, { Children } from 'react';

const Modal = ({ title, showModal, onHide, onSaveChanges, width, showHeader = true, showFooter = true, buttons = [], children, submitButtonTitle, alignment, bodyClasses = '', subTitle }) => {
    const modalWidth = `${width}px`;
    return (
        <>
            <div className={`modal fade ${showModal ? 'show' : ''}`} style={{ display: showModal ? 'block' : 'none' }} tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden={!showModal}>
                <div className={`modal-dialog modal-dialog-centered  ${alignment}`} style={{ maxWidth: modalWidth ? modalWidth : '500px' }} role="document">
                    <div className="modal-content">
                        {showHeader && <div className="modal-header d-flex justify-content-between py-1 bg-primary align-items-center">
                            <h5 className="modal-title" id="exampleModalLabel">{title}{subTitle ? subTitle : ''}</h5>
                            <button type="button" className="close text-white pe-0" onClick={onHide} aria-label="Close">
                                <i className="ri-close-line fs-4"></i>
                            </button>
                        </div>}
                        <div className={`modal-body ${bodyClasses}`}>
                            {children}
                        </div>
                        {showFooter && (
                            <div className="modal-footer">
                                {buttons.length > 0 ? (
                                    buttons.map((button, index) => (
                                        <button key={index} type="button" className={`btn ${button.className}`} onClick={button.onClick}>
                                            {button.label}
                                        </button>
                                    ))
                                ) : (
                                    <>
                                        <button type="button" className="btn btn-secondary" onClick={onHide}>
                                            Close
                                        </button>
                                        <button type="button" className="btn btn-primary" onClick={onSaveChanges}>
                                            {submitButtonTitle}
                                        </button>
                                    </>
                                )}
                            </div>
                        )}
                    </div>
                </div>
            </div>
            {showModal && <div className="modal-backdrop fade show"></div>}
        </>
    );
};

export default Modal;

Modal.defaultProps = {
    alignment: ''
}
